import React, { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./index.scss";
import Footer from "./Footer";
import { BreadCrumb } from "primereact/breadcrumb";
import BreadCrumbService from "../../../services/breadCrumbService";
import { MenuItem } from "../../../@types/menu";
import { Toast } from "primereact/toast";
import ToastService from "../../../services/toastService";
import ConfirmationUtil from "../../../shared/utils/ConfirmationUtil";
import ConfirmationDialog from "../../ConfirmationDialog";
import RequireAuthenticationDialog from "../../RequireAuthenticationDialog";
import AuthenticationUtil from "../../../shared/utils/AuthenticationUtil";
import AuthModel from "../../../model/AuthModel";
import classNames from "classnames";
import If from "../../If";
import { shouldOcultarSidebarEventoInterno } from "../../../../app/shared/utils/EventoInternoUtil";

interface Props {
  children: ReactNode;
  menuItems: MenuItem[];
}

const Default: React.FC<Props> = ({ menuItems, children }) => {
  const [sideBarOpen, setSideBarOpen] = useState(true);
  const [visible, setVisible] = useState(false);
  const auth = new AuthModel();
  const breadCrumb = new BreadCrumbService().getCurrentState();
  const location = useLocation();
  const internalAccess = shouldOcultarSidebarEventoInterno(location.pathname);

  function handleToggleSidebar() {
    localStorage.setItem("isOpen", !sideBarOpen ? "S" : "N");
    if (menuItems.length > 0) {
      setSideBarOpen(!sideBarOpen);
    }
  }

  useEffect(() => {
    ConfirmationUtil.init(setVisible);
    AuthenticationUtil.init(auth);
    if (internalAccess) {
      setSideBarOpen(false);
    } else if (window.innerWidth <= 992) {
      setSideBarOpen(false);
      localStorage.setItem("isOpen", "N");
    }
  }, [internalAccess]);

  useEffect(() => {
    window.addEventListener(
      "resize",
      function () {
        // Não aplica lógica de redimensionamento quando internalAccess for true
        if (internalAccess) return;
        if (window.innerWidth <= 992) {
          setSideBarOpen(false);
          localStorage.setItem("isOpen", "N");
        } else if (
          window.innerWidth > 993 &&
          localStorage.getItem("isOpen") === "N"
        ) {
          setSideBarOpen(true);
          localStorage.setItem("isOpen", "S");
        }
      },
      {}
    );
  }, [menuItems, internalAccess]);

  const home = { icon: "pi pi-home", url: "/" };
  return (
    <>
      <ConfirmationDialog
        reject={ConfirmationUtil.reject}
        visible={visible}
        accept={ConfirmationUtil.accept}
        text={ConfirmationUtil.text}
      />
      <RequireAuthenticationDialog
        accept={AuthenticationUtil.accept}
        reject={AuthenticationUtil.reject}
        auth={auth}
      />
      <div className="default-container">
        <Toast
          baseZIndex={8000}
          ref={(el) => ToastService.init(el)}
          style={{ paddingTop: 40, width: "auto", height: "auto" }}
        />
        <Topbar onClick={handleToggleSidebar} internalAccess={internalAccess} />
        <div className={`default-principal-wrapper`}>
          <If condition={menuItems.length > 0}>
            <Sidebar isOpen={sideBarOpen} menuItems={menuItems} />
            <div
              className={`default-children-wrapper ${classNames({
                "default-children-wrapper-closed": !sideBarOpen,
              })}`}
            >
              <div>
                {!internalAccess && (
                  <BreadCrumb model={breadCrumb.items} home={home} />
                )}
                <div className="default-children">{children}</div>
              </div>
              <Footer />
            </div>
          </If>
          <If condition={menuItems.length <= 0}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                className={`default-children-wrapper ${classNames({
                  "default-children-wrapper-closed": !sideBarOpen,
                })}`}
              >
                <div>
                  <BreadCrumb model={breadCrumb.items} home={home} />
                  <div className="default-children">{children}</div>
                </div>
                <Footer />
              </div>
            </div>
          </If>
        </div>
      </div>
    </>
  );
};

export default Default;
